export default __webpack_public_path__ + "static/media/vietnamska-kava-kafephin.d01a5eeb.jpg";